import { useAuth0 } from "@auth0/auth0-react";
import { useCallback } from "react";
import axios from "axios";

export function useCreateReferralServiceAxiosInstance() {
  const { getAccessTokenSilently } = useAuth0();
  const createReferralServiceAxiosInstance = useCallback(() => {
    const instance = axios.create({
      baseURL: import.meta.env.VITE_REFERRAL_SERVICE_BASE_URL,
    });

    instance.interceptors.request.use(async (req) => {
      req.headers = req.headers.set(
        `Authorization`,
        `Bearer ${await getAccessTokenSilently()}`,
      );
      return req;
    });

    return instance;
  }, [getAccessTokenSilently]);

  return {
    createReferralServiceAxiosInstance,
  };
}
